import { DtoBase } from '../../../types/Dtos/DtoBase'

export class EditHistoryDto extends DtoBase {
  constructor(title: string, description: string) {
    super({ title, description })
  }
}
